/*  Modified by Anam Farrukh on 1/22/2016 */

/**********   DESCRIPTION: ***********/
/* Required parameters for the directive to work:  */
/*  value   : ng-model value from the main controller where directive is used
 *   form    : name of the form
 *   name    : id and name of the element
 *
 *

 *   Optional parameters
 *   change  : on change function from the main controller. Include it in the directive without parameter brackets,
 *             the parameters(if any) from the main controller will automatically be passed through the & binding of the directive
 *   label   : placeholder value
 *   required:
 *   disabled:
 *   min     : if not defined sets the min value = ng-model value
 *   max     : if not defined sets equal to a date in 2099
 *   rebind  : if not defined sets equal to min value
 *   type    : startdate (includes min, max onchange attributes) OR
 *             enddate (includes min, max onchange and rebind attributes) OR
 *             general  (doesnt include rebind, min, max attribute use)
 *
 * */

(function(){
    angular.module('tmx-app').directive("tmxDatepicker", tmxDatePicker);

    function tmxDatePicker() {
        return {
            scope:{
                name:"@",
                value:"=",
                change:'&',
                check:'&',//not used but dont delete
                form:"=",
                showMsg:"=",
                msg:"@",
                label:'@',
                required:"=",
                disabled:"=",
                min: "=",
                max: "=",
                rebind: "=",
                dynamicField:'=',
                dynamicShow:'=',
                type:"@", //startdate OR enddate
                disabledStatic:'@'
            },
            restrict: 'E',
            templateUrl: 'common/directives/tmxdatepicker/tmxdatepicker.html',
            controller: ["$scope","tmxUtility","$element",tmxDatePickerCtrl],
            controllerAs:'datepickerCtrl'

        };
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    var exists;
    function tmxDatePickerCtrl($scope,tmxUtility,$element){
         
        exists=tmxUtility.exists;
        ////////////////////////////////////INITIALIZATIONS/////////////////////////////////////////////////////////////
        var datepickerCtrl=this;
        datepickerCtrl.scope=$scope;
        datepickerCtrl.selfChange=false;
        datepickerCtrl.scope.name = $scope.name;

        if(angular.isDefined($scope.disabledStatic) && !angular.isDefined($scope.disabled)){
            datepickerCtrl.scope.disabled=$scope.disabledStatic == "true";
        }
        datepickerCtrl.isDisabled=function(){
            var result=$scope.disabled=="true" || $scope.disabled==true;
            return result;
        };
        ////////////////KENDO DATETIME PICKER CONFGURATIONS/////////////////////////////////////////////////////////////
        $scope.PickerConfig={
            format: "dd/MM/yyyy"
        };

        ///////////////////////////////MINIMUM AND MAXIMUM VALUE///////////////////////////////////////////////////////////////////////////
        if(!angular.isDefined($scope.min)){
            $scope.min = new Date('01/01/1899');
        }
        else{
            $scope.min = new Date($scope.min);
            if(exists($scope.value)){
                let previouslySetDate = new Date($scope.value);
                if(previouslySetDate < $scope.min){
                    $scope.min= previouslySetDate;
                }
            }
        }

        if(!angular.isDefined($scope.required) || $scope.required == null)
            $scope.required="false";

        if(!angular.isDefined($scope.disabled) || $scope.disabled == null)
            $scope.disabled="false";

        if($scope.disabled=="true")$scope.disabled=true;
        if($scope.disabled=="false")$scope.disabled=false;

        if(!angular.isDefined($scope.max) || $scope.max==null)
            $scope.max = new Date("12-12-2099");//.toJSON();


        $scope.getType=function(value){
            return typeof value;
        }
//////////////////////////////FORM//////////////////////////////////////////////////////////////////////////////////////
        if(angular.isDefined($scope.form))
            datepickerCtrl.form = $scope.form;

//////////////////////////////ON CHANGE FUNCTION/////////////////////////////////////////////////////////////////
        $scope.istouched=function(){
            if(angular.isDefined(datepickerCtrl.scope.form))
                if(angular.isDefined(datepickerCtrl.scope.form[datepickerCtrl.scope.name]))
                    return !angular.isDefined($scope.dynamicField) && angular.isDefined($scope.form) && datepickerCtrl.scope.form[datepickerCtrl.scope.name].$touched;
        }
        $scope.$on("kendoWidgetCreated",function(event, widget){
            if(exists($scope.value)){
                var container=$scope.MyPicker.element.parents('md-input-container');
                if(container.length>0){
                    container.addClass('md-input-has-value');
                }
            }
        });
        datepickerCtrl.onchange = function(ev){
            var value;
            if(ev.sender)
                value=ev.sender.value();
            else
                value=ev;
            datepickerCtrl.selfChange=true;
            $scope.value = value;
            if (angular.isFunction($scope.change)) {
                datepickerCtrl.selfChange = true;
                if (angular.isFunction($scope.change())) {
                    $scope.change()(value, $scope);
                }

                $scope.lastValue = value.toJSON();
            }
        };

        datepickerCtrl.clear = function(){
            $scope.value = undefined;
            $scope.MyPicker._value = undefined;
            $scope.MyPicker.element.val(undefined);
            $($element).find('md-input-container').removeClass('md-input-has-value');
            if (angular.isFunction($scope.change())){
                $scope.change()(null,$scope);
            }
            //datepickerCtrl.scope.form[datepickerCtrl.scope.name].$touched = true;
        }

        function watchMinAndMax(){//if min or max change
            return $scope.min+$scope.max;
        }
        function updateMinAndMax(v1,v2){
            $scope.MyPicker.min($scope.min);//update min
            $scope.MyPicker.max($scope.max);//update max
        }
        $scope.$watch(watchMinAndMax,updateMinAndMax);

    }//end of controller
})();